/**
 * Field Validations
 * @type {{MISSING_REQUIRED_FIELD: string}}
 */
export const VALIDATIONS_ERRORS = {
  MISSING_REQUIRED_FIELD: 'MISSING_REQUIRED_FIELD',
  EXCEEDED_MAX_LENGTH: 'EXCEEDED_MAX_LENGTH',
  EXCEEDED_MAX_SIZE: 'EXCEEDED_MAX_SIZE',
  BELOW_MIN_LENGTH: 'BELOW_MIN_LENGTH',
  BELOW_MIN_SIZE: 'BELOW_MIN_SIZE',
};
/**
 * Field Validations
 * @type {{minlength: Validators.minlength, maxlength: Validators.maxlength, required: Validators.required}}
 */
export const Validators = {
  /**
     * Validate is field is required
     * @param {HTMLElement} element
     * @return {string}
     */
  required: element => {
    if (element.hasAttribute('required')) { // TODO: cache this stuff
      if (!(element.values || []).length && !element.value) { // my have issues with numbers
        return VALIDATIONS_ERRORS.MISSING_REQUIRED_FIELD;
      }
    }
  },
  /**
     * Validate if a number input is below max
     * @param {HTMLElement} element
     * @return {string}
     */
  max: element => {
    const { max } = element;
    const value = Number.parseInt(element.value);
    if (max && value > max) {
      return VALIDATIONS_ERRORS.EXCEEDED_MAX_SIZE;
    }
  },
  /**
     * Validate if a number input is above min
     * @param {HTMLElement} element
     * @return {string}
     */
  min: element => {
    const { min } = element;
    const value = Number.parseInt(element.value);
    if (min && (value || value === 0) && value < min) {
      return VALIDATIONS_ERRORS.BELOW_MIN_SIZE;
    }
  },
  /**
     * Validate if a string length is below maxlength
     * @param {HTMLElement} element
     * @return {string}
     */
  maxlength: element => {
    const { maxlength } = element;
    if (maxlength && (element.value || '').length > maxlength) {
      return VALIDATIONS_ERRORS.EXCEEDED_MAX_LENGTH;
    }
  },
  /**
     * Validate if a string length is above minlength
     * @param {HTMLElement} element
     * @return {string}
     */
  minlength: element => {
    const { minlength } = element;
    if (minlength && (element.value || '').length < minlength) {
      return VALIDATIONS_ERRORS.BELOW_MIN_LENGTH;
    }
  },
};
